import { render, staticRenderFns } from "./ChannelPaymentListAssociationView.vue?vue&type=template&id=8f810e6e&"
import script from "./ChannelPaymentListAssociationView.vue?vue&type=script&lang=js&"
export * from "./ChannelPaymentListAssociationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports